var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: ["calendar", "calendar-wrapper", ..._setup.classList],
      attrs: { "aria-label": "Calendar" },
    },
    [
      _vm._t("header", null, null, _setup.headerProps),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "calendar-header-days" },
        [
          _vm.displayWeekNumbers
            ? _c("div", { staticClass: "calendar-week-number" })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_setup.dayHeaderItems, function (item) {
            return [
              _vm._t(
                "day-header",
                function () {
                  return [
                    _c(
                      "div",
                      {
                        key: item.key,
                        class: ["calendar-header-day", item.key],
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.label) + "\n        "
                        ),
                      ]
                    ),
                  ]
                },
                { index: item.key, label: item.label }
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "calendar-weeks",
          attrs: { "aria-multiselectable": !!_vm.enableDateSelection },
        },
        _vm._l(_setup.weekItems, function (weekItem) {
          return _c(
            "div",
            {
              key: weekItem.key,
              class: [
                "calendar-week",
                `week${weekItem.numberInPeriod}`,
                `ws${weekItem.isoYearMonthDay}`,
              ],
            },
            [
              _vm.displayWeekNumbers
                ? _c(
                    "div",
                    { staticClass: "calendar-week-number" },
                    [
                      _vm._t(
                        "week-number",
                        function () {
                          return [
                            _c("span", [_vm._v(_vm._s(weekItem.numberInYear))]),
                          ]
                        },
                        {
                          date: weekItem.startDate,
                          numberInYear: weekItem.numberInYear,
                          numberInPeriod: weekItem.numberInPeriod,
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "calendar-weekdays" },
                [
                  _vm._l(weekItem.days, function (day) {
                    return _c(
                      _setup.Day,
                      _vm._b(
                        {
                          key: day.dow,
                          on: {
                            click: function ($event) {
                              return _setup.onClickDay(day.date, $event)
                            },
                            dragstart: function ($event) {
                              return _setup.onDragDateStart(day.date, $event)
                            },
                            drop: function ($event) {
                              $event.preventDefault()
                              return _setup.onDrop(day.date, $event)
                            },
                            dragover: function ($event) {
                              $event.preventDefault()
                              return _setup.onDragOver(day.date, $event)
                            },
                            dragenter: function ($event) {
                              $event.preventDefault()
                              return _setup.onDragEnter(day.date, $event)
                            },
                            dragleave: function ($event) {
                              $event.preventDefault()
                              return _setup.onDragLeave(day.date, $event)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "day-content",
                                fn: function () {
                                  return [
                                    _vm._t("day-content", null, null, {
                                      day: day.date,
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        "Day",
                        day,
                        false
                      )
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(weekItem.items, function ({ item, top }) {
                    return [
                      _vm._t(
                        "item",
                        function () {
                          return [
                            (item.itemRow ?? 0) <
                            _setup.maxDisplayableCalendarItems
                              ? _c(
                                  _setup.Item,
                                  _vm._b(
                                    {
                                      key: `${_setup.periodRangeKey}-${item.id}`,
                                      on: {
                                        dragstart: function ($event) {
                                          return _setup.onDragItemStart(
                                            item,
                                            $event
                                          )
                                        },
                                        mouseenter: function ($event) {
                                          return _setup.onMouseEnterItem(
                                            item,
                                            $event
                                          )
                                        },
                                        mouseleave: function ($event) {
                                          return _setup.onMouseLeaveItem(
                                            item,
                                            $event
                                          )
                                        },
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _setup.onClickItem(
                                            item,
                                            $event
                                          )
                                        },
                                      },
                                    },
                                    "Item",
                                    { item, top },
                                    false
                                  )
                                )
                              : _vm._e(),
                          ]
                        },
                        {
                          value: item,
                          weekStartDate: weekItem.startDate,
                          top: top,
                        }
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]
          )
        }),
        0
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }